import React, { HTMLProps, RefObject } from 'react'
import { twMerge } from 'tailwind-merge'
import { Color, Layout } from '../utils/constants'

interface SeparatorProps extends HTMLProps<HTMLDivElement> {
  direction?: Layout
  separatorColor?: Color
  separatorRef?: RefObject<HTMLDivElement>
}

const Separator = ({
    direction = Layout.HORIZONTAL,
    separatorColor = Color.BLACK,
    className,
    separatorRef,
    ...rest
}: SeparatorProps) => {
    const getColor = () => {
        switch (separatorColor) {
        case Color.BLACK:
        default:
            return 'bg-black/10'
        case Color.WHITE:
            return 'bg-white/20'
        }
    }
    return (
        <div ref={separatorRef}>
            <div
                className={twMerge(
                    'transition ease-in duration-300',
                    getColor(),
                    direction === Layout.HORIZONTAL ? 'h-px w-full my-2' : 'w-px h-full mx-2',
                    className,
                )}
                {...rest}
            />
        </div>
    )
}

export default Separator
